export function PageLoading() {
  return (
    <div
      style={{
        padding: 48,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        color: 'var(--apx-text-secondary)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <div
        style={{
          width: 24,
          height: 24,
          border: '2px solid var(--apx-border)',
          borderTopColor: 'var(--apx-accent, #475569)',
          borderRadius: '50%',
          animation: 'apx-spin 1s linear infinite',
        }}
      />
      <p style={{ fontSize: 14, margin: 0 }}>Loading page…</p>
    </div>
  );
}
